import { Extension } from "@tiptap/core";
import { CellSelection } from "@tiptap/pm/tables";

export function setCellBackgroundMarkup(tr, pos, backgroundColor) {
	if (!tr.doc) {
		return tr;
	}

	const node = tr.doc.nodeAt(pos);
	if (!node) {
		return tr;
	}

	if (backgroundColor === node.attrs.backgroundColor) {
		return tr;
	}

	const nodeAttrs = {
		...node.attrs,
		backgroundColor
	};

	return tr.setNodeMarkup(pos, node.type, nodeAttrs, node.marks);
}

export function updateCellBackground(tr, options, backgroundColor) {
	const { doc, selection } = tr;

	if (!doc || !selection || !(selection instanceof CellSelection)) {
		return tr;
	}

	selection.forEachCell((node, pos) => {
		tr = setCellBackgroundMarkup(tr, pos, backgroundColor);
	});

	return tr;
}

export function createCellBackgroundCommand(backgroundColor, options) {
	return ({ tr, state, dispatch }) => {
		const { selection } = state;
		tr = tr.setSelection(selection);
		tr = updateCellBackground(tr, options, backgroundColor);

		if (tr.docChanged) {
			dispatch?.(tr);
			return true;
		}

		return false;
	};
}

// @ts-ignore
export const TableCellBackground =
	Extension.create(
	{
		name: "tableCellBackground",
		addOptions() {
			return {
				types: ["tableCell"],
				HTMLAttributes: {}
			};
		},

		addGlobalAttributes() {
			return [
				{
					types: this.options.types,
					attributes: {
						backgroundColor: {
							parseHTML: element => {
								return element.style.backgroundColor || "";
							},
							renderHTML: attributes => {
								if (
									!attributes.backgroundColor ||
									attributes.backgroundColor === ""
								) {
									return {};
								} else {
									return {
										style: `background-color: ${attributes.backgroundColor}`
									};
								}
							}
						}
					}
				}
			];
		},
		addCommands() {
			return {
				setTableCellBackground: backgroundColor =>
					createCellBackgroundCommand(backgroundColor, this.options),
				unsetTableCellBackground: () => createCellBackgroundCommand("", this.options)
			};
		}
	});
